import { prizeList } from '@/config';
import { goDoc } from '@/utils'
import styles from './index.module.scss';

function ProdWin(props) {
  const { imgIndex = 4, wish = '', desc = '', receive = '' } = prizeList[props.prizeIndex] || {}
  const hasLottery = props.prizeIndex === -2
  const iknowFunc = () => {
    if(props.prizeIndex === 5) {
      return goDoc()
    }
    props.onClick()
  }
  return (
    <div style={ props.style } className={[styles.prodWin, props.className].join('\x20')}>
      <div className={styles.prodMain}>
        {
          hasLottery ? <div className={styles.noInfo}>您已参与过抽奖啦</div>
          :
          <div className={styles.prod}>
            <div className={['prize-prod', 'prize-prod-' + imgIndex, styles.prodImg].join('\x20')}></div>
            <div className={styles.prodInfo}>
              <div className={styles.prodHappy}>{ wish }</div>
              <div className={styles.prodName}>{ desc }</div>
            </div>
          </div>
        }
        <div className={styles.prodDesc}>
          {
            hasLottery ? <span onClick={() => { props.onSeeMyPrize(); props.onClick() }} style={{ display: desc ? 'none' : 'block' }}>查看我的奖品</span> : receive
          }
        </div>
        <div onClick={iknowFunc} className={[styles.iKnow, hasLottery || props.prizeIndex === -1 ? styles.hasLottery : ''].join('\x20')}></div>
      </div>
    </div>
  )
}

export default ProdWin;
